module.exports = __webpack_public_path__ + "img/lars.1a60bf69.png";